export {
  Pagination,
  type PaginationProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Pagination';
